import { render, staticRenderFns } from "./listDisplayColumns.vue?vue&type=template&id=6875d90a&"
import script from "./listDisplayColumns.vue?vue&type=script&lang=js&"
export * from "./listDisplayColumns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports